/**
 * Format phone number to E.164 format for API
 * Default country code is Greece (+30) if no country code is provided
 */
export const formatPhoneE164 = (phone: string, defaultCountryCode: string = '+30'): string => {
  // Remove all non-digit characters
  let cleaned = phone.replace(/\D/g, '');

  // If starts with +, keep it
  if (phone.startsWith('+')) {
    return '+' + cleaned;
  }

  // If already has country code (starts with valid international prefix)
  if (cleaned.startsWith('30') && cleaned.length > 10) {
    return '+' + cleaned;
  }

  // Add default country code
  return defaultCountryCode + cleaned;
};

/**
 * Validate phone number format
 */
export const isPhoneValid = (phone: string): boolean => {
  // E.164 format: + followed by 1-15 digits
  const e164Regex = /^\+?[1-9]\d{1,14}$/;
  const cleaned = phone.replace(/[\s\-\(\)]/g, '');
  return e164Regex.test(cleaned);
};
